import React, { useState, useRef } from 'react';
import LeftSidebar from '../Tools/LeftSidebar';
import Topbar from '../Tools/Topbar';
import Settings from '../Tools/Setting/Settings';
import useSettings from '../Tools/Setting/useSettings';
import ResourceAreaChart from '../Chart/Overview/ResourceAreaChart';
import SpecialityAreaChart  from '../Chart/Overview/SpecialityAreaChart';
import EmployeeAssetUsageChart  from '../Chart/Overview/EmployeeAssetUsageChart';

const ReportsAnalytics = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const { settings, updateSetting, handleColorTheme } = useSettings();
  const settingsRef = useRef();

  return (
    <div id="main-wrapper">
      <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
        <Topbar toggleSidebar={toggleSidebar} />
        <div className="body-wrapper">
          <div className="container-fluid">
            <Settings 
              ref={settingsRef}
              updateSetting={updateSetting}
              handleColorTheme={handleColorTheme}
              settings={settings}  // Add this line
            />
          <h5 class="card-title fw-semibold mb-0 lh-sm">Reports & Analytics</h5>
          <p class="card-subtitle mb-0 mt-1">Insights and history of resource usage, cases, and system activities</p>

          

          <div class="row">
            <div class="col-lg-6 my-2">
              <div class="card reports-analytics w-100 position-relative overflow-hidden">
                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-between mb-4">
                    <h5 class="card-title mb-0 fw-semibold">Resource Utilization</h5>
                  </div>
                  <div class="filter-panel">
                    <form>
                      <div class="form-group col-lg-5 col-12 p-2">
                        <select class="form-control form-select">
                          <option>Resource Type</option>
                          <option>Resource Type 1</option>
                          <option>Resource Type 2</option>
                          <option>Resource Type 3</option>
                        </select>
                      </div>
                      <div class="form-group col-lg-5 col-12 p-2">
                        <select class="form-control form-select">
                          <option>Time Range</option>
                          <option>Last 7 days</option>
                          <option>This Month</option>
                          <option>Last 3 Months</option>
                        </select>
                      </div>
                    </form> 

                    <div class="col-lg-3 col-12 p-2">
                      <select class="form-control form-select">
                        <option>Export to PDF </option>
                        <option>Export to Excel (XLSX)</option>
                        <option>Export to CSV</option>
                      </select>
                    </div>
                  </div>
                  <ResourceAreaChart />
                  
                </div>
              </div>
            </div>

            <div class="col-lg-6 my-2">
              <div class="card reports-analytics w-100 position-relative overflow-hidden">
                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-between mb-4">
                    <h5 class="card-title mb-0 fw-semibold"> Resource Availability History</h5>
                  </div>
                  <div class="filter-panel">
                    <form>
                      <div class="form-group col-lg-4 col-12 p-2">
                        <select class="form-control form-select">
                          <option>Resource Type</option>
                          <option>Resource Type 1</option>
                          <option>Resource Type 2</option>
                          <option>Resource Type 3</option>
                        </select>
                      </div>
                      <div class="form-group col-lg-4 col-12 p-2">
                        <input class="form-control" type="text" value="Resource ID" id=""/>
                      </div>
                      <div class="form-group col-lg-4 col-12 p-2">
                        <select class="form-control form-select">
                          <option>Time Range</option>
                          <option>Last 7 days</option>
                          <option>This Month</option>
                          <option>Last 3 Months</option>
                        </select>
                      </div>
                    </form> 

                    <div class="col-lg-3 col-12 p-2">
                      <select class="form-control form-select">
                        <option>Export to PDF </option>
                        <option>Export to Excel (XLSX)</option>
                        <option>Export to CSV</option>
                      </select>
                    </div>
                  </div>
                 < SpecialityAreaChart />
                  
                </div>
              </div>
            </div>
          </div>

          <div class="card reports-analytics w-100 position-relative overflow-hidden">
            <div class="card-body p-4">
              <h5 class="card-title fw-semibold mb-0 lh-sm">Resource Activity Logs</h5>
              <p class="card-subtitle mb-0 mt-1">View recent actions performed on resources across the system.</p>

              <div class="filter-panel mt-4">
                <form>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <input class="form-control" type="week" value="2011-W33" id="example-week-input"/>
                  </div>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <select class="form-control form-select">
                      <option>Assigned</option>
                      <option>Released</option>
                      <option>Maintenance Start</option>
                    </select>
                  </div>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <input class="form-control" type="text" value="Search By Name" id=""/>
                  </div>
                  
                </form> 

                <div class="col-md-3 col-sm-6 col-12 p-2">
                  <select class="form-control form-select">
                    <option>Export to PDF </option>
                    <option>Export to Excel (XLSX)</option>
                    <option>Export to CSV</option>
                  </select>
                </div>
              </div>
              
              <div class="py-3 px-0">
                <div class="table-responsive rounded-2 ros-table">
                  <table class="table text-nowrap customize-table mb-0 align-middle">
                    <thead class="text-dark fs-4">
                      <tr>
                        <th>
                          <h6 class=" fw-semibold mb-0">Resourcea Name</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Action Performed</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Performed By</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Timestamp</h6>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Server-02</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Assigned</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-22 10:32 AM</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Admin1</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Dr. S. Gupta</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Released</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-21 04:45 PM</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Manager_03</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Generator-A1</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Assigned</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-21 01:10 PM</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Operator_A</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Vehicle-B2</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Maintenance Start</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-20 11:05 AM</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Admin2</p>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
              <div class="py-3 px-0">
                <button type="button" class="btn mb-1 waves-effect waves-light btn-outline-primary">
                  View All Activities
                </button>
              </div>
            </div>
          </div>
          
          <div class="card reports-analytics w-100 position-relative overflow-hidden">
            <div class="card-body p-4">
              <h5 class="card-title fw-semibold mb-0 lh-sm">Resource Status History</h5>
              <p class="card-subtitle mb-0 mt-1">Track all changes in the status of resources over time.</p>

              <div class="filter-panel mt-4">
                <form>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <input class="form-control" type="week" value="2011-W33" id="example-week-input"/>
                  </div>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <select class="form-control form-select">
                      <option>Select Status</option>
                      <option>Available → In Use</option>
                      <option>On Leave → Available</option>
                      <option>Available → Reserved</option>
                    </select>
                  </div>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <input class="form-control" type="text" value="Search By Name" id=""/>
                  </div>
                  
                </form> 

                <div class="col-md-3 col-sm-6 col-12 p-2">
                  <select class="form-control form-select">
                    <option>Export to PDF </option>
                    <option>Export to Excel (XLSX)</option>
                    <option>Export to CSV</option>
                  </select>
                </div>
              </div>
              
              <div class="py-3 px-0">
                <div class="table-responsive rounded-2 ros-table">
                  <table class="table text-nowrap customize-table mb-0 align-middle">
                    <thead class="text-dark fs-4">
                      <tr>
                        <th>
                          <h6 class=" fw-semibold mb-0">Resourcea Name</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Previous Status → New Status</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Date Changed</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Changed By</h6>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Server-02</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Available → In Use</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-22 10:32 AM</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Admin1</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Dr. S. Gupta</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">On Leave → Available</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-21 04:45 PM</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Manager_03</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Generator-A1</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Under Maintenance → Available</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-21 01:10 PM</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Operator_A</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Vehicle-B2</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Available → Reserved</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-20 11:05 AM</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Admin2</p>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
              <div class="py-3 px-0">
                <button type="button" class="btn mb-1 waves-effect waves-light btn-outline-primary">
                  Show More
                </button>
              </div>
            </div>
          </div>

          <div class="card reports-analytics w-100 position-relative overflow-hidden">
            <div class="card-body p-4">
              <h5 class="card-title fw-semibold mb-0 lh-sm">Alert History</h5>
              <p class="card-subtitle mb-0 mt-1">Review all previously triggered system alerts with details.</p>

              <div class="filter-panel mt-4">
                <form>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <input class="form-control" type="week" value="2011-W33" id="example-week-input"/>
                  </div>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <select class="form-control form-select">
                      <option>Select Severity</option>
                      <option>Critical</option>
                      <option>High</option>
                      <option>Medium</option>
                    </select>
                  </div>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <select class="form-control form-select">
                      <option>Select Alert type</option>
                      <option>Low Stock</option>
                      <option>Overuse Detected</option>
                      <option>Maintenance Due</option>
                    </select>
                  </div>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <input class="form-control" type="text" value="Search By Resource" id=""/>
                  </div>
                  
                </form> 

                <div class="col-md-3 col-sm-6 col-12 p-2">
                  <select class="form-control form-select">
                    <option>Export to PDF </option>
                    <option>Export to Excel (XLSX)</option>
                    <option>Export to CSV</option>
                  </select>
                </div>
              </div>
              
              <div class="py-3 px-0">
                <div class="table-responsive rounded-2 ros-table">
                  <table class="table text-nowrap customize-table mb-0 align-middle">
                    <thead class="text-dark fs-4">
                      <tr>
                        <th>
                          <h6 class=" fw-semibold mb-0">Alert Type</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Resource Affected</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Severity</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Date & Time</h6>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Low Stock</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Ventilator-03</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal"><span class="round-8 text-bg-danger rounded-circle me-2 d-inline-block"></span> Critical</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-23 09:15 AM</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Overuse Detected</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Server-01</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal"><span class="round-8 text-bg-warning rounded-circle me-2 d-inline-block"></span> High</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-22 06:30 PM</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Maintenance Due</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Generator-04</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal"><span class="round-8 text-bg-success rounded-circle me-2 d-inline-block"></span>  Medium</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-21 12:10 PM</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Unavailable Staff</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Dr. R. Mehta</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal"><span class="round-8 text-bg-warning rounded-circle me-2 d-inline-block"></span> High</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-21 08:00 AM</p>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
              <div class="py-3 px-0">
                <button type="button" class="btn mb-1 waves-effect waves-light btn-outline-primary">
                  View All Activities
                </button>
              </div>
            </div>
          </div>

          <div class="card reports-analytics w-100 position-relative overflow-hidden">
            <div class="card-body p-4">
              <h5 class="card-title fw-semibold mb-0 lh-sm">User Activity Logs</h5>
              <p class="card-subtitle mb-0 mt-1">Track user interactions across the system for audit and monitoring purposes.</p>

              <div class="filter-panel mt-4">
                <form>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <input class="form-control" type="week" value="2011-W33" id="example-week-input"/>
                  </div>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <select class="form-control form-select">
                      <option>Select Section</option>
                      <option>Resource Management</option>
                      <option>Attendance</option>
                    </select>
                  </div>
                  <div class="form-group col-md-3 col-sm-6 col-12 p-2">
                    <input class="form-control" type="text" value="Search By User" id=""/>
                  </div>
                  
                </form> 

                <div class="col-md-3 col-sm-6 col-12 p-2">
                  <select class="form-control form-select">
                    <option>Export to PDF </option>
                    <option>Export to Excel (XLSX)</option>
                    <option>Export to CSV</option>
                  </select>
                </div>
              </div>
              
              <div class="py-3 px-0">
                <div class="table-responsive rounded-2 ros-table">
                  <table class="table text-nowrap customize-table mb-0 align-middle">
                    <thead class="text-dark fs-4">
                      <tr>
                        <th>
                          <h6 class=" fw-semibold mb-0">User</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Action</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Section</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Timestamp</h6>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Admin1</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Added new resource</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Resource Management</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-23 09:15 AM</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Manager_02</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Updated attendance</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Attendance</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-22 06:30 PM</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Operator_A</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Deleted asset</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Assets</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-21 12:10 PM</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">Admin2</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">Changed user role</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">User Management</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-21 08:00 AM</p>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
              <div class="py-3 px-0">
                <button type="button" class="btn mb-1 waves-effect waves-light btn-outline-primary">
                  View All Activitys
                </button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 mb-4">
              <div class="card reports-analytics w-100 position-relative overflow-hidden mb-0 h-100">
                <div class="card-body p-4">
                  <h5 class="card-title fw-semibold mb-0 lh-sm">Accepted Cases Overview</h5>
                  <p class="card-subtitle mb-0 mt-1">Visualize accepted case trends and track individual case assignments.</p>
    
                  <div class="filter-panel mt-4">
                    <form>
                      <div class="form-group col-md-5 col-sm-6 col-12 p-2">
                        <input class="form-control" type="week" value="2011-W33" id="example-week-input"/>
                      </div>
                      <div class="form-group col-md-5 col-sm-6 col-12 p-2">
                        <select class="form-control form-select">
                          <option>Select Status</option>
                          <option>Active</option>
                          <option>Completed</option>
                        </select>
                      </div>
                    </form> 
    
                    <div class="col-md-3 col-sm-6 col-12 p-2">
                      <select class="form-control form-select">
                        <option>Export to PDF </option>
                        <option>Export to Excel (XLSX)</option>
                        <option>Export to CSV</option>
                      </select>
                    </div>
                  </div>
                  
                  <div class="py-3 px-0">
                    <div class="table-responsive rounded-2 ros-table">
                      <div class="table-responsive rounded-2 ros-table">
                        <table class="table text-nowrap customize-table mb-0 align-middle">
                          <thead class="text-dark fs-4">
                            <tr>
                              <th>
                                <h6 class=" fw-semibold mb-0">Case ID</h6>
                              </th>
                              <th>
                                <h6 class=" fw-semibold mb-0">Case Name</h6>
                              </th>
                              <th>
                                <h6 class=" fw-semibold mb-0">Assigned Date</h6>
                              </th>
                              <th>
                                <h6 class=" fw-semibold mb-0">Status</h6>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <p class="mb-0 fw-normal">C-1024</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">Emergency Drill</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">2025-06-23</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">Active</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p class="mb-0 fw-normal">C-1025</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">Server Upgrade</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">2025-06-22</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">Completed</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p class="mb-0 fw-normal">C-1026</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">Field Operation</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">2025-06-22</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">In Progress</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p class="mb-0 fw-normal">C-1027</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">Health Camp</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">2025-06-21</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">Completed</p>
                              </td>
                            </tr>
      
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="py-3 px-0">
                    <button type="button" class="btn w-100 mb-1 waves-effect waves-light btn-outline-primary">
                      View All 
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6 mb-4">
              <div class="card reports-analytics w-100 position-relative overflow-hidden mb-0 h-100">
                <div class="card-body p-4">
                  <h5 class="card-title fw-semibold mb-0 lh-sm">Rejected Cases Overview</h5>
                  <p class="card-subtitle mb-0 mt-1">Monitor rejected case trends and identify resource constraints or reasons for rejection.</p>
    
                  <div class="filter-panel mt-4">
                    <form>
                      <div class="form-group col-md-5 col-sm-6 col-12 p-2">
                        <input class="form-control" type="week" value="2011-W33" id="example-week-input"/>
                      </div>
                      <div class="form-group col-md-5 col-sm-6 col-12 p-2">
                        <select class="form-control form-select">
                          <option>Select Status</option>
                          <option>Active</option>
                          <option>Completed</option>
                        </select>
                      </div>
                    </form> 
    
                    <div class="col-md-3 col-sm-6 col-12 p-2">
                      <select class="form-control form-select">
                        <option>Export to PDF </option>
                        <option>Export to Excel (XLSX)</option>
                        <option>Export to CSV</option>
                      </select>
                    </div>
                  </div>
                  
                  <div class="py-3 px-0">
                    <div class="table-responsive rounded-2 ros-table">
                      <div class="table-responsive rounded-2 ros-table">
                        <table class="table text-nowrap customize-table mb-0 align-middle">
                          <thead class="text-dark fs-4">
                            <tr>
                              <th>
                                <h6 class=" fw-semibold mb-0">Case ID</h6>
                              </th>
                              <th>
                                <h6 class=" fw-semibold mb-0">Case Name</h6>
                              </th>
                              <th>
                                <h6 class=" fw-semibold mb-0">Assigned Date</h6>
                              </th>
                              <th>
                                <h6 class=" fw-semibold mb-0">Status</h6>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <p class="mb-0 fw-normal">C-1024</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">Emergency Setup</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">2025-06-23</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">No Available Assets</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p class="mb-0 fw-normal">C-1025</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">Health Checkup</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">2025-06-19</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">No Specialist</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p class="mb-0 fw-normal">C-1026</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">Field Operation</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">2025-06-22</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">In Progress</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p class="mb-0 fw-normal">C-1027</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">Field Visit</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">2025-06-18</p>
                              </td>
                              <td>
                                <p class="mb-0 fw-normal">Conflict in Schedule</p>
                              </td>
                            </tr>
      
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="py-3 px-0">
                    <button type="button" class="btn w-100 mb-1 waves-effect waves-light btn-outline-primary">
                      View All 
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-8">
                      <h5 class="card-title fw-semibold mb-0 lh-sm">Capacity Usage Per Time</h5>
                    </div>
                    <div class="col-md-4">
                      <select class="form-control form-select">
                        <option>Export to PDF </option>
                        <option>Export to Excel (XLSX)</option>
                        <option>Export to CSV</option>
                      </select>
                    </div>
                  </div>

                  <div class="table-responsive rounded-2 ros-table">
                  <table class="table text-nowrap customize-table mb-0 align-middle">
                    <thead class="text-dark fs-4">
                      <tr>
                        <th>
                          <h6 class=" fw-semibold mb-0">Date</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Employee Usage (%)</h6>
                        </th>
                        <th>
                          <h6 class=" fw-semibold mb-0">Asset Usage (%)</h6>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-01</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">60%</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">55%</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-02</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">68%</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">63%</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-03</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">75%</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">70%</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="mb-0 fw-normal">2025-06-04</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">72%</p>
                        </td>
                        <td>
                          <p class="mb-0 fw-normal">69%</p>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                  </div>
                  
                </div>

                <div class="col-md-6 mt-md-0 mt-4">
                  <div class="row reports-analytics">
                    <div class="col-md-12 ">
                      <h5 class="card-title fw-semibold mb-0 lh-sm">Capacity Usage Per Time</h5>
                    </div>
                    
                    <div class="filter-panel mt-4">
                      <form>
                        <div class="form-group col-lg-5 p-2">
                          <select class="form-control form-select">
                            <option>Select Month</option>
                            <option>Jan</option>
                            <option>Feb</option>
                            <option>Mar</option>
                          </select>
                        </div>
                        <div class="form-group col-lg-5 p-2">
                          <select class="form-control form-select">
                            <option>Department</option>
                            <option>Department one</option>
                            <option>Department two</option>
                            <option>Department three</option>
                          </select>
                        </div>
                      </form> 
  
                      <div class="col-lg-3 p-2">
                        <select class="form-control form-select">
                          <option>Export to PDF </option>
                          <option>Export to Excel (XLSX)</option>
                          <option>Export to CSV</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  < EmployeeAssetUsageChart />
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

          </div>
        </div>
  
  );
};

export default ReportsAnalytics;